import { useFormContext } from 'react-hook-form';
import type { RuleTypeMutation } from '../types';

const useRulePageMode = () => {
  const { getValues } = useFormContext();
  const mode = getValues('mode') as RuleTypeMutation;
  return {
    isRead: mode === 'read',
    isEdit: mode === 'edit',
    isDuplicate: mode === 'duplicate',
  };
};

export default useRulePageMode;
